import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {Config} from '../..';
import {PaginationControlsDirective} from 'ngx-pagination';

export interface PaginationRange {
  page: number;
  limit: number;
}

@Component({
    selector: 'pagination',
    templateUrl: './pagination.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PaginationComponent implements OnChanges {
  @ViewChild('paginationDirective')
  paginationDirective: PaginationControlsDirective;
  @ViewChild('paginationRange') paginationRange;
  @Input() pagination;
  @Input() config: Config;
  @Input() id;
  @Output() readonly update: EventEmitter<PaginationRange> = new EventEmitter();
  public ranges: number[] = [5, 10, 25, 50, 100, 250];
  public selectedLimit: number;
  public showRange = false;
  public screenReaderPaginationLabel = 'Pagination';
  public screenReaderPageLabel = 'page';
  public screenReaderCurrentLabel = 'You are on page';
  public previousLabel = '';
  public nextLabel = '';
  public directionLinks = true;

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: any): void {
    if (this.paginationRange && !this.paginationRange.nativeElement.contains(targetElement)) {
      this.showRange = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { config } = changes;
    if (config && config.currentValue) {
      this.selectedLimit = this.config.rows;
    }
  }

  onPageChange(page: number): void {
    this.update.emit({
      page,
      limit: this.getLimit(),
    });
  }

  getLimit(): number {
    return this.pagination?.limit || this.selectedLimit;
  }

  changeLimit(limit: number, callFromAPI: boolean): void {
    if (!callFromAPI) {
      this.showRange = !this.showRange;
    }
    this.selectedLimit = limit;
    this.update.emit({
      page: 1,
      limit,
    });
  }
}
